module.exports = __webpack_public_path__ + "static/media/GoogleLogo.791dc5e4.webp";